var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"relative"},[(_vm.fulfilSrc)?_c('img',{staticClass:"db w-100",attrs:{"src":_vm.src}}):_c('img',{staticClass:"db loading_img",attrs:{"src":_vm.url}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c9f0a14","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/loading.vue
// module id = null
// module chunks = 